<template>
  <div style="padding: 10px">
    <div style="margin: 10px 0">
      <!-- 角色选择框 -->
      <el-select
          v-model="search.roleId"
          placeholder="选择角色"
          style="width: 20%"
          clearable
          filterable
      >
        <el-option
            v-for="role in roleList"
            :key="role.roleId"
            :label="`${role.accountName} (${role.roleId})`"
            :value="role.roleId"
        >
        </el-option>
      </el-select>

      <!-- 日志类型选择框 -->
      <el-select v-model="search.logType" placeholder="日志类型" style="width: 20%" clearable>
        <el-option
            v-for="item in logTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>

      <!-- 异常报错选择框 -->
      <el-select v-model="search.error" placeholder="异常报错" style="width: 20%" clearable>
        <el-option
            v-for="item in errorOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>

      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="accountName"
          label="角色名"
          width="150"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="tokenId"
          label="角色Token"
          width="150"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="content"
          label="日志内容"
      >
      </el-table-column>
      <el-table-column
          prop="logTime"
          label="时间"
          width="150"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="logType"
          label="日志类型"
          :formatter="formatLogType"
          width="150"
          show-overflow-tooltip>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'towerFormation',
  components: {},
  data() {
    return {
      dialogVisible: false,
      form: {
        createTime: '',
      },
      userId: '',
      loading: true,
      search: {
        roleId: '',
        logType: '',
        error: ''
      },
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      // 角色列表
      roleList: [],

      // 日志类型选项（从接口获取）
      logTypeOptions: [],
      // 错误选项
      errorOptions: [
        {label: '是', value: 1},
        {label: '否', value: 0}
      ],

      // 日志类型映射（用于表格格式化）
      logTypeMap: {}
    }
  },
  created() {
    // 初始化用户信息
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;

    // 加载角色列表
    this.loadRoleList();

    // 加载日志类型
    this.loadLogTypes();

    // 加载日志数据
    this.load();
  },
  methods: {
    // 加载角色列表
    loadRoleList() {
      request.get("/accountInfoWs/listResponse", {
        params: {
          current: 1,
          size: 1000 // 设置一个较大的size值获取所有数据
        }
      }).then(res => {
        if (res.code === '0' && res.data) {
          if (Array.isArray(res.data.records)) {
            // 从分页数据中获取
            this.roleList = res.data.records
                .filter(item => item.roleId) // 过滤掉没有roleId的项
                .map(item => ({
                  id: item.id,
                  accountName: item.accountName || `用户${item.roleId}`,
                  roleId: item.roleId
                }));
          } else if (Array.isArray(res.data)) {
            // 如果直接返回数组
            this.roleList = res.data
                .filter(item => item.roleId)
                .map(item => ({
                  id: item.id,
                  accountName: item.accountName || `用户${item.roleId}`,
                  roleId: item.roleId
                }));
          }

          // 按accountName排序
          this.roleList.sort((a, b) => {
            if (a.accountName < b.accountName) return -1;
            if (a.accountName > b.accountName) return 1;
            return 0;
          });
        } else {
          console.error('加载角色列表失败:', res.msg);
          this.roleList = [];
        }
      }).catch(error => {
        console.error('加载角色列表失败:', error);
        this.roleList = [];
      });
    },

    // 加载日志类型
    loadLogTypes() {
      request.get("/xyzwws/websocket/logType").then(res => {
        if (res.code === '0' && res.data) {
          // 将接口返回的对象转换为下拉选项格式
          this.logTypeOptions = Object.entries(res.data).map(([value, label]) => ({
            value: parseInt(value),
            label: label
          }));

          // 按value排序
          this.logTypeOptions.sort((a, b) => a.value - b.value);

          // 保存到映射表，用于表格格式化
          this.logTypeMap = res.data;
        } else {
          // 如果接口失败，使用默认值
          this.setDefaultLogTypes();
        }
      }).catch(error => {
        console.error('加载日志类型失败:', error);
        // 如果接口失败，使用默认值
        this.setDefaultLogTypes();
      });
    },

    // 设置默认的日志类型
    setDefaultLogTypes() {
      this.logTypeOptions = [
        {label: '未知', value: 0},
        {label: '收菜', value: 1},
        {label: '踢人/申请', value: 2},
        {label: '人员同步', value: 3},
        {label: '盐场同步', value: 4},
        {label: '宝库助力', value: 5},
        {label: '俱乐部签到', value: 6},
        {label: '改阵容名称', value: 7},
        {label: '每日任务', value: 8},
        {label: '赛车', value: 9},
        {label: '梦境', value: 10},
        {label: '竞技场', value: 11},
        {label: '怪异塔', value: 12},
        {label: '咸将塔', value: 13},
        {label: '限时活动', value: 15}
      ];

      // 创建映射表
      this.logTypeMap = {};
      this.logTypeOptions.forEach(item => {
        this.logTypeMap[item.value] = item.label;
      });
    },

    // 格式化日志类型显示
    formatLogType(row, column, cellValue) {
      return this.logTypeMap[cellValue] || `未知类型(${cellValue})`;
    },

    // 重置搜索条件
    resetData() {
      this.search = {
        roleId: '',
        logType: '',
        error: ''
      }
      this.currentPage = 1;
      this.load();
    },

    // 加载日志数据
    load() {
      this.loading = true;

      // 构建查询参数
      const params = {
        current: this.currentPage,
        size: this.pageSize
      };

      // 添加搜索条件
      if (this.search.roleId !== '' && this.search.roleId !== undefined && this.search.roleId !== null) {
        params.roleId = this.search.roleId;
      }
      if (this.search.logType !== '' && this.search.logType !== undefined && this.search.logType !== null) {
        params.logType = this.search.logType;
      }
      if (this.search.error !== '' && this.search.error !== undefined && this.search.error !== null) {
        params.error = this.search.error;
      }

      request.get("/wsLog/list", {
        params: params
      }).then(res => {
        this.loading = false;

        if (res.code === '0') {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = [];
        this.total = 0;
      });
    },

    // 改变每页显示数量
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },

    // 改变当前页码
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    },
  }
}
</script>

<style scoped>
/* 可选的样式调整 */
.el-select {
  margin-right: 10px;
}

.el-table {
  margin-top: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
